import { motion } from "motion/react";
import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const MotionCollapsableContainerStyled = styled(
  motion.section,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "motion-collapsable-container-styled",
})`
  overflow: auto;
`;
